import { Outlet } from "react-router-dom"

import { Menu } from "@/components/common/menu"
import { useCompanyQuery } from "@/features/company/hooks/use-company-query"
import { cn } from "@/utils"
import { useUIStore } from "@/store/ui-store"

export function AppLayout() {
  const { isSidebarCollapsed } = useUIStore()
  // Dispara a busca pelos dados da empresa assim que o layout é renderizado.
  useCompanyQuery()

  return (
    <div className="min-h-screen bg-background text-text antialiased">
      <Menu />

      <div
        className={cn(
          "transition-all duration-300",
          isSidebarCollapsed ? "pl-20" : "pl-56",
        )}
      >
        <header className="flex h-16 items-center border-b border-background-subtle px-6">
          <h1 className="text-lg font-bold">Painel Admin</h1>
        </header>

        <main className="p-8">
          <Outlet />
        </main>
      </div>
    </div>
  )
}